import { debounce } from 'lodash-es';

/**
 * Update the layout of the masonry grid at the current screen size
 * @param {HTMLElement} masonryEl The element which should be or has already been initialied with masonry
 */
function updateLayout(masonryEl) {
  // Define breakpoints for layout updates
  const smallBreakpoint = window.matchMedia('(min-width: 30em)');
  const mediumBreakpoint = window.matchMedia('(min-width: 48em)');
  const largeBreakpoint = window.matchMedia('(min-width: 80em)');
  const extraLargeBreakpoint = window.matchMedia('(min-width: 90em)');

  let masonry;

  // Create or assign masonry instance
  if (Masonry.data(masonryEl)) {
    masonry = Masonry.data(masonryEl);
  } else {
    masonry = new Masonry(masonryEl, {
      itemSelector: '.artwork-card',
      fitWidth: true,
      horizontalOrder: true,
      initLayout: false,
    });
  }

  // Set varying gutter sizes at different breakpoints
  if (extraLargeBreakpoint.matches) {
    masonry.options = {
      ...masonry.options,
      gutter: 32,
    };
  } else if (largeBreakpoint.matches) {
    masonry.options = {
      ...masonry.options,
      gutter: 24,
    };
  } else if (mediumBreakpoint.matches) {
    masonry.options = {
      ...masonry.options,
      gutter: 16,
    };
  } else if (smallBreakpoint.matches) {
    masonry.options = {
      ...masonry.options,
      gutter: 8,
    };
  }

  // Only apply masonry if lowest breakpoint is met
  // N.B. destroy is a 'soft' destroy
  if (smallBreakpoint.matches) {
    masonry.layout();
  } else {
    masonry.destroy();
  }
}

// TODO: Update the event listener here when we have a nicer solution for image dimensions
export default window.addEventListener('load', () => {
  const gridEl = document.querySelector('.artwork-grid__inner');

  if (!gridEl) return;

  updateLayout(gridEl);

  window.addEventListener(
    'resize',
    debounce(() => {
      updateLayout(gridEl);
    }, 1000),
  );
});
